import * as React from 'react';
import logoStacked from '../../assets/images/embue-color-tm.png';
import { Icon } from '@mui/material';
import { useIsSmallScreen } from '../../system/SystemMediaQueriesProvider';

export const Logo = () => {
  const isSmallScreen = useIsSmallScreen();

  return (
    <Icon
      sx={{
        width: isSmallScreen ? '64px' : '100%',
        padding: '0px',
        marginLeft: '14px',
        marginRight: '14px',
        height: '46px',
        textAlign: 'center',
      }}
    >
      <img src={logoStacked} alt="logo" width="100%" />
    </Icon>
  );
};
